// 非空正则
export const REG_NOT_EMPTY = /\S/

// 仅中文正则
export const REG_CHINESE = /^[\u4e00-\u9fa5]+$/

// 手机号正则
export const REG_PHONE = /^1[3-9]\d{9}$/

// 身份证号正则
export const REG_IDENTITY = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/

// 验证码长度校验
export const REG_MESSAGE_CODE = /^\d{6}$/

//银行卡号
export const REG_BANKACCOUNT = /^[1-9]\d{12,18}$/ // 非 0 开头 + 12-18位数字

